import isNaN from 'lodash-es/isNaN'
import { useMemo } from 'react'

import { IconPreviewItem as LMFIconPreviewItem } from '@syconium/little-miss-figgy'

import { EmbroideryService } from '../../../../containers/EmbroideryService'
import { IconFormValues } from '../../../../containers/EmbroideryService/types'
import { EmbroideryPlacementOffset } from '../../../../types/graphql'

export const IconPreviewItem = <T extends Omit<IconFormValues, '__type'>>({
  values,
}: {
  values: T
}) => {
  const { backgroundImage } = EmbroideryService.useContainer()
  const backgroundImageOffsetsByKey = backgroundImage?.embroideryOffsets || {}

  const backgroundImageOffsets: EmbroideryPlacementOffset | undefined = values.iconPlacement
    ?.offsetKey
    ? backgroundImageOffsetsByKey[values.iconPlacement.offsetKey]
    : undefined

  const xOffset: string | undefined = backgroundImageOffsets?.x
  const yOffset: string | undefined = backgroundImageOffsets?.y
  const rotation: number | undefined = backgroundImageOffsets?.rotation
  const backgroundImageScale: number = backgroundImageOffsets?.scale ?? 1

  const iconScale = useMemo(() => {
    // The "scale" here is arbitrary JSON and could be a string or a number
    const scale = parseFloat(String(values.iconImage?.embroideryOffsets?.scale) ?? 1)
    // Return default scale if not a valid number
    if (isNaN(scale)) return 1
    return scale
  }, [values])

  const previewItem: JSX.Element | null = useMemo(() => {
    return values.iconPlacement ? (
      <LMFIconPreviewItem
        iconImageName={values.iconImage?.caption}
        iconImageSource={values.iconImage?.source}
        iconScale={iconScale}
        initials={values.initials}
        initialsColor={values.initialsColor}
        rotation={rotation}
        scale={backgroundImageScale}
        xOffset={xOffset}
        yOffset={yOffset}
      />
    ) : null
  }, [
    iconScale,
    backgroundImageScale,
    values.iconImage,
    values.iconPlacement,
    values.initials,
    values.initialsColor,
    rotation,
    xOffset,
    yOffset,
  ])

  return previewItem
}
